import { Authorisation } from "@iventis/domain-model/model/authorisation";
import { Node } from "@iventis/domain-model/model/node";
import { NodeType } from "@iventis/domain-model/model/nodeType";
import { Status } from "@iventis/domain-model/model/status";
import { FlatLibraryNode, NodeServices } from "@iventis/tree-browser";

export function createMockNodeServices(rootNode: Node, numberOfChildrenPerNode: number): NodeServices<Node> {
    return {
        getTree: () => Promise.resolve(rootNode),
        addNode: (node: Node) => Promise.resolve(node),
        deleteNodes: (nodes: Node[]) => Promise.resolve(nodes.map(({ id }) => id)),
        updateNode: (node: Node) => Promise.resolve(node),
        moveNodes: () => Promise.resolve(),
        copyNodes: () => Promise.resolve(),
        getNode: (nodeId: string) => {
            const node = rootNode.childNodes.find((node) => node.id === nodeId);
            node.childNodes = createNodes(numberOfChildrenPerNode, NodeType.Layer, node.id);
            node.childCount = numberOfChildrenPerNode;
            return Promise.resolve(node);
        },
        getNodeThumbnails: {
            [NodeType.Map]: () => Promise.resolve({}),
            [NodeType.Layer]: () => Promise.resolve({}),
        },
        getParents: () => null,
    };
}

export const getInteractivityMock = () => ({
    selectable: { disabled: false, tooltip: "" },
    disabled: false,
    draggable: true,
    isNameClickable: false,
});

export const createRootNode = (numberOfNodes: number) => {
    const mainNode = createNode(NodeType.Folder, null, 0);
    mainNode.childNodes = createNodes(numberOfNodes, NodeType.Map, mainNode.id);
    mainNode.childCount = numberOfNodes;
    return mainNode;
};

const createNodes = (amount: number, type: NodeType, parentId: string) => {
    const nodes = [];
    for (let i = 0; i <= amount; i += 1) {
        nodes[i] = createNode(type, parentId, i);
    }
    return nodes;
};
const createNode = (type: NodeType, parentId: string, index: number): FlatLibraryNode => {
    const id = `${type.toString()}-${index}`;
    return {
        id,
        name: id,
        authorisation: Authorisation.Admin,
        type,
        favourite: false,
        expanded: false,
        childNodes: [],
        childCount: 100,
        createdByUserId: "user-id",
        createdByUserName: "user",
        createdAt: new Date(),
        lastUpdatedByUserId: "user-id",
        lastUpdatedByUserName: "user",
        lastUpdatedAt: new Date(),
        lastViewedAt: new Date(),
        sourceId: id,
        status: Status.Active,
        parentId,
    };
};
